'use client';

import {
  FC,
  PropsWithChildren,
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState
} from 'react';

const FeedbackContext = createContext<{
  feedbackMessage: string | null;
  showFeedback: boolean;
  updateFeedback: (value: string) => void;
  dismissFeedback: () => void;
}>(null);

export const useFeedback = () => useContext(FeedbackContext);

export const FeedbackProvider: FC<PropsWithChildren> = ({ children }) => {
  const [feedback, setFeedback] = useState<string | null>(null);

  const updateFeedback = useCallback((value: string) => {
    setFeedback(value);
  }, []);

  const dismissFeedback = useCallback(() => {
    setFeedback(null);
  }, []);

  const feedBackContext = useMemo(
    () => ({
      feedbackMessage: feedback,
      showFeedback: Boolean(feedback),
      updateFeedback,
      dismissFeedback
    }),
    [dismissFeedback, updateFeedback, feedback]
  );

  return (
    <FeedbackContext.Provider value={feedBackContext}>
      {children}
    </FeedbackContext.Provider>
  );
};
